// Host family for Dealer.com imagery, including the CloudFront pictures-proxy
// aliases (`pictures.web.dealer.com`, `pictures-np.web-np.dealer.com`).
const DDC_IMAGE_HOST =
	/(?:^|\/\/)(pictures|images|static)(-np)?\.([a-z0-9-]+\.)*dealer\.com(?=[/:?#]|$)/i;
// Dealer-supplied photos sit under a single-letter path root.
const DEALER_PHOTO_PATH = /(?:^|\/\/)[^/]*\/[a-zA-Z]\//;

export default (eventType) => {
	if (!window?.DDC?.dataLayer?.vehicles?.[0]) {
		return null;
	}

	const vehicleImage = window.DDC.dataLayer.vehicles[0].images[0];

	// vehicleImage can either be a string or an object
	const imageLink =
		typeof vehicleImage === 'object' ? vehicleImage.uri : vehicleImage;

	if (imageLink.includes('fd-FD_DEALERSERVICES_IMAGES')) {
		return `vinreal:${eventType}`;
	}

	// We are testing for something like pictures.dealer.com/a/
	if (DDC_IMAGE_HOST.test(imageLink) && DEALER_PHOTO_PATH.test(imageLink)) {
		return `dealer:${eventType}`;
	}

	return `stock:${eventType}`;
};
